import { render, staticRenderFns } from "./LabFormSheet.vue?vue&type=template&id=08d930c0&scoped=true"
import script from "./LabFormSheet.vue?vue&type=script&lang=js"
export * from "./LabFormSheet.vue?vue&type=script&lang=js"
import style0 from "./LabFormSheet.vue?vue&type=style&index=0&id=08d930c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d930c0",
  null
  
)

export default component.exports